import { CircularProgressProps, default as MuiCircularProgress } from '@mui/material/CircularProgress'

export const CircularProgress = (props: CircularProgressProps) => {
  return <MuiCircularProgress {...props} color="secondary" aria-label="loading" />
}

export default CircularProgress
